/**
 * Created by Ning Jiang on 2023-11-15.
 */

import {WinPresentationController} from "../WinPresentationController";
import {DevilsCrossRoad} from "../../DevilsCrossRoad";
import {DevilsCrossRoadSound} from "../../sound/DevilsCrossRoadSound";
import {gsap} from "gsap";

export class RemoveWinSymbolsController extends WinPresentationController {

    private _delayBeforeRemove:number[] = [0.1, 0.1, 0.1, 0.1];

    constructor() {
        super("RemoveWinSymbolsController", false);
    }

    protected hasWin():boolean {
        return true;
    }

    protected async createWinAnimation():Promise<any> {
        const tl = gsap.timeline();
        const removeTl = DevilsCrossRoad.reels.reelView.removeAllWinSymbols();
        if(removeTl.totalDuration() > 0) {
            tl.add([
                () => {
                    DevilsCrossRoadSound.playAvalancheSound();
                    DevilsCrossRoadSound.soundPlayer.playTrack({name : DevilsCrossRoadSound.WIN_REMOVE});
                    if(DevilsCrossRoad.model.randomWilds?.length > 0) {
                        DevilsCrossRoadSound.soundPlayer.playTrack({name : DevilsCrossRoadSound.WILD_REMOVE});
                    }
                    const winLevel = DevilsCrossRoad.model.currentWinRatioConfig?.winLevel!;
                    DevilsCrossRoad.backgroundElements.setMainFrame(winLevel > 1 ? "glow_fast" : "big_glow_fast", false);
                },
                removeTl
            ], this._delayBeforeRemove[DevilsCrossRoad.model.currentWinRatioConfig?.winLevel!]);
            return Promise.resolve(tl);
        }
        return Promise.resolve();
    }
}